import type { BeforeRequestHook } from 'ky';
import { HTTP_HEADERS } from '../../../../auth/const';
import { getLongId } from '../../../id';
import isNative from '../../../native/isNative';
import { trackNetwork } from '../../../tracking';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const getMetadataHeaders = ({
  fetchArgs: { url, method, data },
  baseURL,
}: HookGetterArgs): BeforeRequestHook => {
  const metadataHeadersHook: BeforeRequestHook = async (request) => {
    // s_ for requests sent from server, c_ for requests sent from client, n_ for requests sent from native
    let prefix = isServer() ? 's_' : 'c_';
    if (isNative()) {
      prefix = 'n_';
    }
    const uniqueId = `${prefix}${getLongId()}`;
    const startTime = new Date().toISOString();

    request.headers.set(HTTP_HEADERS.TraceId, uniqueId);
    request.headers.set(HTTP_HEADERS.Timestamp, startTime);
    const timezone =
      typeof Intl === 'undefined' ? 'UTC' : Intl.DateTimeFormat().resolvedOptions().timeZone;
    request.headers.set(HTTP_HEADERS.Timezone, timezone);

    // track network metrics for client side requests matrix requests
    if (!isServer()) {
      trackNetwork(uniqueId, { url });
    }

    // don't log this in development, since we're now logging end time
    if (isServer() && process.env.NODE_ENV !== 'development') {
      const { headers: nextHeaders } = await import('next/headers');
      const header = await nextHeaders();
      const serverRequestId = header.get(HTTP_HEADERS.UIServerRequestId);

      const params = {
        url: baseURL,
        traceId: uniqueId,
        timestamp: startTime,
      };
      if (serverRequestId) {
        params[HTTP_HEADERS.UIServerRequestId] = serverRequestId;
      }

      console.debug(`[${method}] ${baseURL} start`, {
        payload: data,
        params,
      });
    }
  };

  return metadataHeadersHook;
};
